// 热更新HTML页面
if (process.env.NODE_ENV !== 'production') {
  require('html-loader!./index.html')
}

import { Carousel, CarouselItem } from 'element-ui'

Vue.use(Carousel)
Vue.use(CarouselItem)

new Vue({
  data() {
    return {
      option: [
        {
          id: 0,
          img: require('__IMG__/1.0.0/img_gxjsqy.png').default,
        },
        {
          id: 1,
          img: require('__IMG__/1.0.0/img_rjzzq2.png').default,
        },
        {
          id: 2,
          img: require('__IMG__/1.0.0/img_hydw2.png').default,
        },
        {
          id: 3,
          img: require('__IMG__/1.0.0/img_zscq.png').default,
        },
        {
          id: 4,
          img: require('__IMG__/1.0.0/img_fmzl.png').default,
        },
        {
          id: 5,
          img: require('__IMG__/1.0.0/img_hydw.png').default,
        },
        {
          id: 6,
          img: require('__IMG__/1.0.0/img_rjzzq.png').default,
        },
      ],
    }
  },
}).$mount('#honor')

// 首页banner视频
$('#play').on('click', function () {
  document.getElementsByClassName('bannervideo')[0].style.display = 'block'
  document.getElementById('video1').play()
})
$('#vidimg').on('click', function () {
  document.getElementsByClassName('bannervideo')[0].style.display = 'none'
  document.getElementById('video1').pause()
})

const About_us = $('#About_us')
About_us.find('.tabs_ul .item')
  .on('click', function () {
    const self = $(this)
    self.siblings().css({ color: '#333333' })
    self.css({ color: '#1B9D97' })

    const index = self.index()
    About_us.find(`.show-content:eq(${index})`).show().siblings().hide()
  })
  .eq(0)
  .click()

//地图初始化时，在地图上添加一个marker标记,鼠标点击marker可弹出自定义的信息窗体
var map = new AMap.Map('container', {
  resizeEnable: true,
  center: [113.920683, 22.4985],
  zoom: 20,
})
map.clearMap()
//添加marker标记
var marker = new AMap.Marker({
  position: [113.920683, 22.499204],
})
map.add(marker)
